import { useState } from "react";
import { Pagination } from "../../../components";
import { dateToHumanFormat } from "../../../utils/constants";
import useConfigOptions from "../../../hooks/useConfigOptions";
import { Link, useLocation } from "react-router-dom";
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';

function Table({ loans, metadata, handlePagination }) {

    const { loanStates } = useConfigOptions();
    const { pathname } = useLocation();
    const path = pathname.split("/")[1];
    const [currentPage, setCurrentPage] = useState(metadata?.currentPage || 1);
    const nPages = metadata?.totalPages;

    const isActiveOrCompleted = path === "active-loans" || path === "completed-loans";

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
            <table className="min-w-full">
                <thead>
                    <tr className="bg-gray-50/60 dark:bg-gray-900/60 border-b border-gray-100 dark:border-gray-700">
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide w-[28%]">Full Name</th>
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Phone No.</th>
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Amount Elig.</th>
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                            {isActiveOrCompleted ? 'Disbursed On' : 'Applied On'}
                        </th>
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Stage</th>
                        <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Details</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                    {loans && loans.length > 0 ? (
                        loans.map(item => (
                            <tr key={item._id} className="hover:bg-gray-50/40 dark:hover:bg-gray-700/30 transition-colors">
                                <td className="px-5 py-3.5">
                                    <div className="flex items-center gap-2 flex-wrap">
                                        <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
                                            {item?.client?.otherNames} {item?.client?.surname}
                                        </span>
                                        {item?.state !== loanStates.completed && item?.daysInDelinq >= 1 && (
                                            <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 border border-red-100 dark:border-red-500/20 rounded-full">
                                                {item.daysInDelinq} days in arrears
                                            </span>
                                        )}
                                    </div>
                                </td>
                                <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">
                                    {item?.phone}
                                </td>
                                <td className="px-5 py-3.5 text-sm font-semibold text-gray-800 dark:text-gray-100 tabular-nums">
                                    GHS {item?.amount}
                                </td>
                                <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">
                                    {isActiveOrCompleted ? dateToHumanFormat(item?.dateDisbursed) : dateToHumanFormat(item?.createdAt)}
                                </td>
                                <td className="px-5 py-3.5">
                                    <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-500/20 rounded-full uppercase">
                                        Active
                                    </span>
                                </td>
                                <td className="px-5 py-3.5">
                                    <Link
                                        to={`/admin/${item?.type?.toLowerCase()}/${item._id}`}
                                        className="inline-flex items-center gap-1 text-xs font-medium text-[#1e3a6e] dark:text-blue-400 hover:text-[#264d91] dark:hover:text-blue-300 transition-colors"
                                    >
                                        View
                                        <HugeiconsIcon icon={ArrowRight01Icon} size={12} />
                                    </Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="px-5 py-12 text-center text-sm text-gray-400">
                                No loan applications found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {loans && loans.length > 0 && (
                <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    length={metadata?.totalCount}
                    handlePagination={handlePagination}
                />
            )}
        </div>
    );
}

export default Table;
